import { render, staticRenderFns } from "./TiersControl.vue?vue&type=template&id=4596f7c9&"
import script from "./TiersControl.vue?vue&type=script&lang=js&"
export * from "./TiersControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports